import { Col, Row } from 'react-bootstrap';
import ESpinner from 'components/others/Spinner';
import TitleCounter from 'components/others/TitleCounter';
import OffCreate from './OffCreate';
import OffFilter from './OffFilter';
import OffView from './OffView';
import SupplierRequestsTable from './SupplierRequestsTable';
import SupplierRequestsToolBar from './SupplierRequestsToolBar';
import useCloneSupplierRequest from './model/useCloneSupplierRequest';
import useSupplierRequests from './model/useSupplierRequests';

const SupplierRequests = () => {
    const {
        t,
        canOps,
        requests,
        showSpinner,
        filter,
        draftFilter,
        setDraftFilter,
        showFilter,
        setShowFilter,
        createVendorId,
        createDraft,
        createCloneFromId,
        createKey,
        openCreate,
        closeCreate,
        viewRequestId,
        setViewRequestId,
        triggerListReset,
        triggerListRefresh,
        fetchRequests,
        handleOpenFilter,
        handleApplyFilter,
        handleResetFilter,
    } = useSupplierRequests();

    const { cloneRequest } = useCloneSupplierRequest({
        onClone: (vendorId, sourceRequestId) =>
            openCreate(vendorId, { cloneFromRequestId: sourceRequestId }),
    });

    return (
        <Row>
            <Col className="col-sticky" sm={12}>
                <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start">
                    <div>
                        <h4 className="p-0 m-0 mb-0 me-2 text-break">{t('supplierRequests.title')}</h4>
                        <TitleCounter />
                    </div>
                    <div className="mt-2 mt-sm-0">
                        <SupplierRequestsToolBar
                            canOps={canOps}
                            filter={filter}
                            onReset={triggerListReset}
                            onRefresh={triggerListRefresh}
                            onOpenFilter={handleOpenFilter}
                            onVendorSelected={(vendorId) => openCreate(vendorId)}
                        />
                    </div>
                </div>
            </Col>

            <Col sm={12}>
                <div className="px-0">
                    {requests == null ? (
                        <ESpinner />
                    ) : (
                        <SupplierRequestsTable
                            requests={requests}
                            showSpinner={showSpinner}
                            canOps={canOps}
                            onOpen={(requestId) => {
                                closeCreate();
                                setViewRequestId(requestId);
                            }}
                            onClone={cloneRequest}
                            onChanged={triggerListRefresh}
                        />
                    )}
                </div>
            </Col>

            <OffFilter
                show={showFilter}
                draftFilter={draftFilter}
                setDraftFilter={setDraftFilter}
                onApply={handleApplyFilter}
                onReset={handleResetFilter}
                onHide={() => setShowFilter(false)}
            />

            <OffCreate
                vendorId={createVendorId}
                initialDraft={createDraft}
                cloneFromRequestId={createCloneFromId}
                createKey={createKey}
                onClose={closeCreate}
                onSaved={() => {
                    void fetchRequests(true);
                }}
            />

            <OffView
                requestId={viewRequestId}
                canOps={canOps}
                onClose={() => setViewRequestId(null)}
                onChanged={triggerListRefresh}
            />
        </Row>
    );
};

export default SupplierRequests;
